import React from 'react'
import './NotFound.scss'
import NotFoundImage from '../Assets/NotFound.svg'

const NotFound = () => {
  return (
    <div className='NotFound'>
      <img src={NotFoundImage} alt='' draggable={false}/>
      <h1>"Oh no! Something went wrong!.."</h1>
      <span>This page is feeling a little broken... just like our sad little dessert...</span>
    </div>
  )
}

export default NotFound